import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { ServiceMark } from './AmdenMark';

export const ServiceCard = ({ name, color, description, areas, href, icon: Icon, testid, linkTestid }) => (
  <article
    data-testid={testid}
    className="group relative flex h-full flex-col rounded-xl border border-slate-200 bg-white p-7 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-lift"
    style={{ borderTopWidth: '3px', borderTopColor: color }}
  >
    {Icon ? (
      <span
        className="flex h-12 w-12 items-center justify-center rounded-lg"
        style={{ backgroundColor: `${color}1A`, color }}
      >
        <Icon className="h-6 w-6" aria-hidden="true" />
      </span>
    ) : (
      <ServiceMark color={color} className="h-12 w-12" />
    )}
    <h3 className="mt-5 text-lg font-extrabold tracking-tight text-navy-900">{name}</h3>
    <p className="mt-3 text-sm leading-relaxed text-slate-600">{description}</p>
    {areas && areas.length > 0 && (
      <ul className="mt-5 space-y-2.5">
        {areas.map((area) => (
          <li key={area} className="flex items-start gap-2.5 text-sm font-medium text-navy-800">
            <Check className="mt-0.5 h-4 w-4 shrink-0" style={{ color }} aria-hidden="true" />
            {area}
          </li>
        ))}
      </ul>
    )}
    <Link
      to={href}
      data-testid={linkTestid}
      className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-bold transition-colors"
      style={{ color }}
    >
      Learn more
      <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
    </Link>
  </article>
);
